import { tradeApi } from '@/api/exchange.page';
import { mapGetters } from 'vuex';
import { socketName } from '@/common/constants/globalConfig';
import tool from '@/common/js/tool';
import { getterTypes } from '@/store/getter-types';
import DepthComponent from '../Depth';

const INDEX_PRICE = 0;
const INDEX_VOLUME = 1;
const INDEX_AMOUNT = 2;

export default {
  name: 'DepthData',
  components: {
    DepthComponent
  },
  data() {
    return {
      loading: true,
      // 当前合并深度
      currentMergeDepth: {
        mergeType: 'step0',
        value: 0.01
      },
      // 深度数据
      depthData: {
        buy: [],
        sell: [],
        // 卖出
        asks: [],
        // 买入
        bids: [],
        // 人民币
        platformPrice: 0,
        price: 0,
        // 卖出数据最大值
        maxAsksVolume: 0,
        // 买入数据最大值
        maxBidsVolume: 0
      },
      // 卖出累计值最大值
      maxAsksGrandTotal: 0,
      // 买入累计值最大值
      maxBidsGrandTotal: 0,
      lastSubscribeChannel: '',
      // lastPrice: 0,

      //new data
      currentLastPrice: null,
      previousLastPrice: null,
      type: null,
      depthGroupOptions: null
    };
  },
  props: {
    model: {
      type: Object,
      default: {
        buy: [],
        sell: []
      }
    },
    depthOptions: {
      type: Array,
      default: null
    },
    activeDepth: {
      type: String,
      default: null
    },
    lastPrice: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  methods: {
    // updateLastPrice(price, type) {
    //   if (null == this.currentLastPrice) {
    //     this.currentLastPrice = price;
    //     this.type = type;
    //   } else {
    //     this.previousLastPrice = this.currentLastPrice;

    //     if (price == this.previousLastPrice) {
    //       this.type = null;
    //     } else {
    //       this.currentLastPrice = price;
    //       this.type = type;
    //     }
    //   }

    //   return;
    // },
    onDepthRowClick(item) {
      console.log('item--->', item);
      if (!isNaN(this.Getter_User_Info.id) && Number(this.Getter_User_Info.id) < 999999) {
        console.log('item2--->', item);
        // this.$parent.$refs.exchangeForm.$refs.priceBuy[0].model = item.price;
        // this.$parent.$refs.exchangeForm.$refs.priceSell[0].model = item.price;
        // this.$parent.$refs.exchangeForm.$refs.volumeBuy[0].model = item.volume;
        // this.$parent.$refs.exchangeForm.$refs.volumeSell[0].model = item.volume;
        this.$emit('rowClickPrice', item.price);
        this.$emit('rowClickVol', item.volume);
      } else {
        console.log('item2--->', item)
        this.$emit('rowClickPrice', item.price);
        // this.$parent.$refs.exchangeForm.$refs.priceBuy[0].model = item.price;
        // this.$parent.$refs.exchangeForm.$refs.priceSell[0].model = item.price;
        // this.$parent.$refs.exchangeForm.$refs.volumeBuy[0].model = "";
        // this.$parent.$refs.exchangeForm.$refs.volumeSell[0].model = "";
      }
    },
    // 获取深度数据
    async getDepthData() {
      let depthData = {};
      let depthSellData = [];
      let asksPrice;
      let bidsPrice;
      if (!this.depthData) {
        depthData.data = {
          sell: [],
          buy: []
        };
      }
      // depthData.data.asks.reverse();
      depthData = this.depthData;
      if (depthData != undefined && depthData.sell.length > 0) {
        this.maxAsksGrandTotal = depthData.sell[0].grandTotal;
        asksPrice = depthData.sell[0].price;
      } else {
        this.maxAsksGrandTotal = 0;
      }
      if (depthData != undefined && depthData.buy.length > 0) {
        this.maxBidsGrandTotal = depthData.buy[depthData.buy.length - 1].grandTotal;
        bidsPrice = depthData.buy[depthData.buy.length - 1].price;
      } else {
        this.maxBidsGrandTotal = 0;
      }
      depthData.sell = depthData.sell.reverse();
      this.depthData = depthData;
      this.loading = false;
      this.scrollToBottom();
    },
    // 获取买入深度图、卖出深度图的最大值
    processDepthData() {
      let { asks, bids } = this.depthData;
      let maxAsksVolume = this.depthData.maxAsksVolume;
      let maxBidsVolume = this.depthData.maxBidsVolume;
      for (let i = 0, len = asks.length; i < len; i++) {
        maxAsksVolume = Math.max(maxAsksVolume, asks[i].volume);
      }
      for (let i = 0, len = bids.length; i < len; i++) {
        maxBidsVolume = Math.max(maxBidsVolume, bids[i].volume);
      }
      this.depthData.maxAsksVolume = maxAsksVolume;
      this.depthData.maxBidsVolume = maxBidsVolume;
    },
    scrollToBottom() {
      this.$nextTick(() => {
        if (this.$refs.scroll_box) {
          let ele = this.$refs.scroll_box;
          ele.scrollTo(0, ele.scrollHeight);
        }
      });
    },
    // 订阅深度数据
    // subscribeDepth() {
    //   let $socket = this.$socket2.get(socketName.exchange);
    //   let symbol = this.Getter_Current_Market.symbol.toLowerCase();
    //   let mergeDepth = this.currentMergeDepth.mergeType;
    //   let channel = `market.${symbol}.depth.${mergeDepth}`;
    //   // 订阅当前交易区时，把之前的交易区取消掉
    //   this.unSubscribeDepth();

    //   $socket.subscribe(channel, data => {
    //     let depthData = data.tick;
    //     if (!depthData) {
    //       depthData = {
    //         asks: [],
    //         bids: [],
    //       };
    //     }
    //     let depthData2 = {
    //       ...depthData,
    //     };
    //     delete depthData2.asks;
    //     delete depthData2.bids;
    //     // depthData.maxAsksVolume = 0;
    //     // depthData.maxBidsVolume = 0;

    //     // depthData.asks.reverse();
    //     if (depthData.asks.length > 0) {
    //       this.maxAsksGrandTotal = depthData.asks[0].grandTotal;
    //     } else {
    //       this.maxAsksGrandTotal = 0;
    //     }
    //     if (depthData.bids.length > 0) {
    //       this.maxBidsGrandTotal = depthData.bids[depthData.bids.length - 1].grandTotal;
    //     } else {
    //       this.maxBidsGrandTotal = 0;
    //     }
    //     this.depthData = depthData;
    //     this.$emit('depthDataLoaded', depthData2);
    //     // this.processDepthData();
    //   }, {
    //     sub: channel,
    //   });
    //   this.lastSubscribeChannel = channel;
    // },
    // 取消订阅深度数据
    // unSubscribeDepth() {
    //   let lastSubscribeChannel = this.lastSubscribeChannel;
    //   if (lastSubscribeChannel) {
    //     this.$socket2.get(socketName.exchange).unSubscribe(lastSubscribeChannel, { cancel: lastSubscribeChannel });
    //   }
    // },
    // 深度数据点击事件
    // depthDataItemClick(e) {
    //   let target = e.target || e.srcElement;
    //   this.$emit('setInputPrice', target.getAttribute('data-price') * 1);
    // },
    // findPrice(prices, target, asc) {
    //   const INDEX_PRICE = 0;
    //   if (prices.length > 0) {
    //     let head = 0;
    //     let tail = prices.length - 1;

    //     if (asc) {
    //       while (head < tail) {
    //         let i = Math.floor((head + tail) / 2);
    //         if (Number(prices[i][INDEX_PRICE]) < Number(target)) {
    //           head = i + 1;
    //         } else if (Number(prices[i][INDEX_PRICE]) > Number(target)) {
    //           tail = i - 1;
    //         } else {
    //           return {
    //             found: true,
    //             index: i,
    //           };
    //         }
    //       }
    //       if (head == tail) {
    //         if (Number(prices[head][INDEX_PRICE]) == Number(target)) {
    //           return {
    //             found: true,
    //             index: head,
    //           };
    //         } else {
    //           if (Number(prices[head][INDEX_PRICE]) < Number(target)) {
    //             head++;
    //           }
    //           return {
    //             found: false,
    //             index: head,
    //           };
    //         }
    //       }
    //       return {
    //         found: false,
    //         index: head,
    //       };
    //     } else {
    //       while (head < tail) {
    //         let i = Math.floor((head + tail) / 2);
    //         if (Number(prices[i][INDEX_PRICE]) > Number(target)) {
    //           head = i + 1;
    //         } else if (Number(prices[i][INDEX_PRICE]) < Number(target)) {
    //           tail = i - 1;
    //         } else {
    //           return {
    //             found: true,
    //             index: i,
    //           };
    //         }
    //       }
    //       if (head == tail) {
    //         if (Number(prices[head][INDEX_PRICE]) == Number(target)) {
    //           return {
    //             found: true,
    //             index: head,
    //           };
    //         } else {
    //           if (Number(prices[head][INDEX_PRICE]) > Number(target)) {
    //             head++;
    //           }
    //           return {
    //             found: false,
    //             index: head,
    //           };
    //         }
    //       }
    //       return {
    //         found: false,
    //         index: head,
    //       };
    //     }
    //   }
    //   return {
    //     found: false,
    //     index: 0,
    //   };
    // },

    // 深度下拉菜单点击事件
    depthItemClick(data) {
      if (data.value === this.currentMergeDepth.value) {
        return;
      }

      // this.currentMergeDepth = {
      //   mergeType: data.text,
      //   value: data.value,
      // };

      // this.$emit('depthDataLoaded', this.currentMergeDepth);
      // this.getDepthData();
      // this.subscribeDepth();
    },

    getPrecision(flag /* 1 = priceDec, 2 = volDec */) {
      if (this.Getter_Current_Market) {
        if (flag === 1) {
          return this.Getter_Current_Market.priceDec;
        } else if (flag === 2) {
          return this.Getter_Current_Market.volDec;
        } else if (flag === 3) {
          /* return this.Getter_Current_Market.priceDec > this.Getter_Current_Market.volDec ?
            this.Getter_Current_Market.priceDec : this.Getter_Current_Market.volDec; */
          return this.Getter_Current_Market.priceDec + this.Getter_Current_Market.volDec;
        }
      }
      return '';
    },

    createDecimals(decimalCount) {
      let start = 1;
      let prepended = '';
      while (start < decimalCount) {
        prepended += '0';
        start++;
      }

      return '0.' + prepended + '1';
    },
    viewCurrentDepth(activeDepth) {
      for (let item of this.depthOptions) {
        if (item.value === activeDepth) {
          return item.text;
        }
      }
      return '';
    },
    // padStartZero: tool.padStartZero,
    decimalRetain: tool.decimalRetain
  },
  computed: {
    ...mapGetters([getterTypes.Getter_Current_Market, getterTypes.Getter_Current_Currency, getterTypes.Getter_User_Info]),
    viewDepth() {
      return this.$t('labels.trade.depth') + ' ' + this.viewCurrentDepth(this.activeDepth);
    },
    currentDepth: {
      get() {
        return this.activeDepth;
      },
      set(value) {
        this.$emit('update:activeDepth', value);
      }
    }
  },
  watch: {
    Getter_Current_Market() {
      // let groups = this.Getter_Current_Market.mergeDepth.split(",").reverse();
      // // groups = [5,4,3,2,1,0,-1,-2,-3,-4,-5];
      // //use base ten to simplify the process
      // let options = groups.map(item => {
      //   let value = Number(item);
      //   let response = {
      //     text: "",
      //     value: "",
      //   };
      //   if (value > 0) {
      //     response.text = `D${value}`;
      //     response.value = 1 / Math.pow(10, value);
      //   } else {
      //     if (0 == value) {
      //       response.text = `I1`;
      //     } else {
      //       response.text = `I${Math.pow(10, -value)}`;
      //     }
      //     response.value = Math.pow(10, -(value));
      //   }
      //   return response;
      // });
      // this.currentMergeDepth.value = options[options.length - 1].value;
      // this.depthGroupOptions = options;
      // this.getDepthData();
      // this.subscribeDepth();
    }
  },
  mounted() {
    if (this.Getter_Current_Market.symbol) {
      // this.lastPrice = this.Getter_Current_Market.close;
      // this.getDepthData();
      // this.subscribeDepth();
      // this.currentMergeDepth.value = this.depthOptions[0].value;
    }
  },
  beforeDestroy() {
    // this.unSubscribeDepth();
  }
};
